import { render, staticRenderFns } from "./InputsSenderVendor.vue?vue&type=template&id=648a1772&"
import script from "./InputsSenderVendor.vue?vue&type=script&lang=js&"
export * from "./InputsSenderVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports